import { useStore } from '@/utils/store';
import {
	fetchAccEmailDomains,
	addAccEmailDomain,
	verifyDkim,
	sendVerifyReplyToEmail,
	verifyReplyToEmailOtp,
} from '@/store/modules/accountEmailDomains/actions';
import { AccountEmailDomainPayload, AccountEmailDomainId, AccountEmailDomainResponse } from '@/api/account_email_domains';

export const useAccountEmailDomainActions = () => {
	const { dispatch } = useStore();
	return {
		fetchAccEmailDomains: () => dispatch<undefined, void>(fetchAccEmailDomains, undefined),
		addAccEmailDomain: (payload: AccountEmailDomainPayload) =>
			dispatch<AccountEmailDomainPayload, AccountEmailDomainResponse>(addAccEmailDomain, payload),
		verifyDkim: (payload: AccountEmailDomainId) => dispatch<AccountEmailDomainId, AccountEmailDomainResponse>(verifyDkim, payload),
		sendVerifyReplyToEmail: (email: string) => dispatch<string, AccountEmailDomainResponse>(sendVerifyReplyToEmail, email),
		verifyReplyToEmailOtp: (otp: number) => dispatch<number, AccountEmailDomainResponse>(verifyReplyToEmailOtp, otp),
	};
};
